<script setup>
import Dropdown from 'primevue/dropdown';

const model = defineModel()

const tiposPergunta = [
    { name: 'Múltipla escolha', value: 1 },
    { name: 'Dissertativa', value: 2 }
];

</script>

<template>
    <div class="flex flex-column gap-2">
        <label for="tipoPergunta">Tipo de pergunta</label>
        <Dropdown id="tipoPergunta" v-model="model" :options="tiposPergunta" optionLabel="name"
            optionValue="value" placeholder="Selecione um tipo de pergunta" class="w-full" />
    </div>
</template>
